import React from 'react';
import {createRoot} from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from './redux/app-store';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import ScrollToTop from './utils/scrollToTop';
import App from './App';

const pathBaseName = window.location.pathname.includes('/finance/qualify') ? '/finance/qualify' : '/finance/prequalify';
window.pathBaseName = pathBaseName;

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <Provider store={store}>
      <Router basename={pathBaseName}>
        <ScrollToTop/>
        <App/>
      </Router>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
